<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">Добавить заявку</h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'claims' }">← Назад к Заявкам</router-link>
    </div>

    <claim-add-form @after="handleAfter" />

  </div>
</template>

<script>
import claimAddForm from '@/components/forms/claim/ClaimAddForm'

export default {
  name: 'claim-add',
  components: { claimAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'claims' })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClaimAdd.vue?a8899c36